var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-49",
    "data-name": "50_Kids_Icons-49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1691",
    "data-name": "Path 1691",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1690",
    "data-name": "Path 1690",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z",
    fill: "#ffc34a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5108",
    "data-name": "Group 5108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5083",
    "data-name": "Group 5083",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_533",
    "data-name": "Ellipse 533",
    cx: 18.75,
    cy: 23.438,
    rx: 18.75,
    ry: 23.438,
    transform: "translate(21.25 22.813)",
    fill: "#a14b2a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5084",
    "data-name": "Group 5084",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1692",
    "data-name": "Path 1692",
    d: "M152.947,246.493c1.025,2.428.467,4.787-1.247,5.27s-3.933-1.093-4.958-3.521-.467-4.787,1.247-5.27S151.922,244.065,152.947,246.493Z",
    transform: "translate(-123.38 -204.934)",
    fill: "#e68c6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1693",
    "data-name": "Path 1693",
    d: "M320,246.492c-1.025,2.428-.467,4.787,1.247,5.27s3.933-1.093,4.958-3.521.467-4.787-1.247-5.27S321.025,244.065,320,246.492Z",
    transform: "translate(-269.567 -204.934)",
    fill: "#e68c6f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5085",
    "data-name": "Group 5085",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1695",
    "data-name": "Path 1695",
    d: "M128.4,412.258l-.008-.132c0-8-2.995-15.753-6.652-17.229l-15.575-6.275a20.633,20.633,0,0,0-13.3-.017l-15.8,6.312c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132Z",
    transform: "translate(-59.397 -326.964)",
    fill: "#e68c6f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5086",
    "data-name": "Group 5086",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1697",
    "data-name": "Path 1697",
    d: "M226.979,277.007a6.219,6.219,0,0,1-6.219,6.219h-.754a6.219,6.219,0,0,1-6.219-6.219V260.989a6.219,6.219,0,0,1,6.219-6.219h.754a6.219,6.219,0,0,1,6.219,6.219Z",
    transform: "translate(-180.384 -214.962)",
    fill: "#e68c6f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5088",
    "data-name": "Group 5088",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5087",
    "data-name": "Group 5087",
    transform: "translate(26.617 21.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1699",
    "data-name": "Path 1699",
    d: "M197.113,161.2c0,5.279-4.666,9.558-10.423,9.558h-5.923c-5.756,0-10.422-4.279-10.422-9.558v-15.64c0-5.278,4.666-9.558,10.422-9.558h5.923c5.757,0,10.423,4.279,10.423,9.558Z",
    transform: "translate(-170.346 -136)",
    fill: "#f5b29c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5089",
    "data-name": "Group 5089",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_534",
    "data-name": "Ellipse 534",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(33.321 40.012)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_535",
    "data-name": "Ellipse 535",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(43.584 40.012)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5090",
    "data-name": "Group 5090",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1702",
    "data-name": "Path 1702",
    d: "M244.43,279.542a2.384,2.384,0,0,1-4.653.538,2.526,2.526,0,0,0-.114.71,2.553,2.553,0,1,0,5.105,0A2.516,2.516,0,0,0,244.43,279.542Z",
    transform: "translate(-202.216 -235.864)",
    fill: "#f59576"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5091",
    "data-name": "Group 5091",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1704",
    "data-name": "Path 1704",
    d: "M128.39,425.067c0-8-3-15.753-6.652-17.229l-12.384-4.989a10.937,10.937,0,0,1-19.889.053l-12.4,4.956c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132h58Z",
    transform: "translate(-59.398 -339.904)",
    fill: "#78bede"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5094",
    "data-name": "Group 5094",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5092",
    "data-name": "Group 5092",
    transform: "translate(31.426 36.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1706",
    "data-name": "Path 1706",
    d: "M201.974,235.912a4.644,4.644,0,0,1,3.443-1.435.5.5,0,0,0,0-1.005,5.654,5.654,0,0,0-4.154,1.729c-.435.479.274,1.192.711.711Z",
    transform: "translate(-201.127 -233.472)",
    fill: "#a14b2a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5093",
    "data-name": "Group 5093",
    transform: "translate(43.798 36.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1707",
    "data-name": "Path 1707",
    d: "M284.948,235.2a5.654,5.654,0,0,0-4.154-1.729.5.5,0,0,0,0,1.005,4.643,4.643,0,0,1,3.443,1.435c.437.48,1.146-.233.711-.711Z",
    transform: "translate(-280.309 -233.472)",
    fill: "#a14b2a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5096",
    "data-name": "Group 5096",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5095",
    "data-name": "Group 5095",
    transform: "translate(34.513 47.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1709",
    "data-name": "Path 1709",
    d: "M230.622,306.564c-1.751,2.825-6.743,2.833-8.5.016-.448-.714-1.58-.056-1.13.664,2.288,3.661,8.491,3.65,10.768-.02.446-.72-.689-1.374-1.133-.66Z",
    transform: "translate(-220.884 -306.255)",
    fill: "#a91935"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5107",
    "data-name": "Group 5107",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5101",
    "data-name": "Group 5101",
    transform: "translate(9.979 21.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5099",
    "data-name": "Group 5099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5097",
    "data-name": "Group 5097"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1711",
    "data-name": "Path 1711",
    d: "M75.125,181.662c-.49-.506,1.355-3.478.795-3.979-.527-.471-3.367,1.616-3.925,1.118-.531-.473,1.281-3.473.75-4-.507-.5-3.522,1.314-4.005.747-.461-.54,1.827-3.192,1.408-3.813-.395-.585-3.725.527-4.065-.145-.316-.625,2.548-2.645,2.293-3.359-.234-.656-3.733-.388-3.9-1.13-.157-.678,3.094-2,3-2.754-.088-.69-3.571-1.127-3.6-1.889-.029-.7,3.4-1.441,3.426-2.2.022-.7-3.364-1.634-3.295-2.39.064-.7,3.562-1.021,3.669-1.771.132-.924-3-2.592-2.717-3.474s3.807-.449,4.225-1.282-2.058-3.372-1.524-4.14c.524-.753,3.788.657,4.418-.038.616-.679-1.125-3.777-.418-4.4.69-.6,3.541,1.524,4.309.984.75-.528-.3-3.925.515-4.387.8-.453,3.182,2.188,4.036,1.8.838-.379.425-3.912,1.307-4.221s2.755,2.713,3.659,2.48,1.085-3.783,2-3.939,2.263,3.135,3.193,3.056S92.377,135,93.31,135",
    transform: "translate(-63.867 -134.997)",
    fill: "none",
    stroke: "#a14b2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5098",
    "data-name": "Group 5098",
    transform: "translate(6.64 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    "data-name": "Path 1712",
    d: "M114.766,181.477c-.4-.545,1.877-3.193,1.421-3.734-.431-.512-3.518,1.174-3.972.627-.426-.513,1.852-3.164,1.43-3.739-.392-.535-3.639.795-4.007.18-.339-.566,2.371-2.776,2.068-3.43-.276-.6-3.72.042-3.954-.643-.211-.621,2.9-2.232,2.729-2.937-.151-.638-3.655-.658-3.763-1.374-.1-.65,3.234-1.729,3.176-2.449-.053-.657-3.52-1.169-3.535-1.889-.014-.661,3.424-1.338,3.445-2.056.019-.663-3.38-1.52-3.33-2.234.047-.663,3.531-1.046,3.607-1.756.085-.79-3.177-2.115-3.01-2.875s3.688-.614,3.937-1.351-2.643-2.752-2.315-3.459,3.733.2,4.136-.467-1.99-3.254-1.516-3.876,3.6,1,4.14.428-1.25-3.6-.654-4.111,3.3,1.745,3.952,1.306-.439-3.79.254-4.155,2.832,2.432,3.563,2.149.436-3.792,1.2-3.986,2.175,3.028,2.955,2.928S128.062,135,128.851,135",
    transform: "translate(-106.361 -134.999)",
    fill: "none",
    stroke: "#a14b2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5100",
    "data-name": "Group 5100",
    transform: "translate(9.765 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1713",
    "data-name": "Path 1713",
    d: "M134.766,181.477c-.4-.545,1.877-3.193,1.421-3.734-.431-.512-3.518,1.174-3.972.627-.426-.513,1.852-3.164,1.43-3.739-.393-.535-3.639.795-4.007.18-.339-.566,2.371-2.776,2.068-3.43-.276-.6-3.72.042-3.954-.643-.211-.621,2.9-2.232,2.729-2.937-.151-.638-3.655-.658-3.763-1.374-.1-.65,3.234-1.729,3.176-2.449-.053-.657-3.52-1.169-3.535-1.889-.014-.661,3.424-1.338,3.445-2.056.019-.663-3.38-1.52-3.33-2.234.047-.663,3.531-1.046,3.607-1.756.085-.79-3.177-2.115-3.01-2.875s3.688-.614,3.937-1.351-2.643-2.752-2.315-3.459,3.733.2,4.136-.467-1.99-3.254-1.516-3.876,3.6,1,4.14.428-1.25-3.6-.654-4.111,3.3,1.745,3.952,1.306-.439-3.79.254-4.155,2.832,2.432,3.563,2.149.436-3.792,1.2-3.986,2.175,3.028,2.955,2.928S148.062,135,148.851,135",
    transform: "translate(-126.361 -134.999)",
    fill: "none",
    stroke: "#a14b2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5106",
    "data-name": "Group 5106",
    transform: "translate(37.766 21.216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5104",
    "data-name": "Group 5104",
    transform: "translate(2.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5102",
    "data-name": "Group 5102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1714",
    "data-name": "Path 1714",
    d: "M275.417,179.934c.49-.506,3.4,1.476,3.966.975.527-.471-1.211-3.513-.653-4.01.531-.473,3.418,1.543,3.949,1.02.507-.5-1.5-3.368-1.021-3.935.461-.54,3.638.962,4.056.341.395-.585-2.193-2.946-1.853-3.619.316-.625,3.757.061,4.012-.654.234-.656-2.854-2.318-2.682-3.06.157-.678,3.665-.788,3.761-1.545.088-.69-3.273-1.7-3.242-2.464.029-.7,3.467-1.406,3.444-2.166-.022-.7-3.5-1.215-3.565-1.971-.064-.7,3.265-1.82,3.158-2.57-.132-.924-3.68-1.063-3.961-1.945s2.541-3.033,2.123-3.866-3.836.133-4.371-.636c-.524-.753,1.58-3.615.95-4.31-.616-.679-3.684,1.12-4.391.5-.69-.6.7-3.876-.069-4.416-.75-.528-3.372,1.877-4.187,1.415-.8-.453-.072-3.935-.926-4.32-.838-.379-2.976,2.465-3.859,2.156s-.761-3.861-1.666-4.094-2.517,2.935-3.437,2.779-1.4-3.679-2.327-3.758-1.992,3.314-2.925,3.314",
    transform: "translate(-259.702 -135.784)",
    fill: "none",
    stroke: "#a14b2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5103",
    "data-name": "Group 5103",
    transform: "translate(0.313 0.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1715",
    "data-name": "Path 1715",
    d: "M273,180.333c.4-.545,3.536,1.039,3.991.5.431-.512-1.756-3.237-1.3-3.784.426-.513,3.564,1.066,3.986.491.392-.535-2.083-3-1.715-3.618.339-.566,3.7.432,4-.222.276-.6-2.654-2.509-2.42-3.194.211-.621,3.7-.33,3.87-1.035.151-.638-3.089-1.968-2.98-2.683.1-.65,3.591-.937,3.649-1.657.053-.657-3.343-1.52-3.328-2.24.014-.661,3.448-1.36,3.428-2.078-.019-.663-3.485-1.181-3.535-1.9-.047-.663,3.316-1.654,3.24-2.364-.085-.79-3.6-1.014-3.765-1.773-.17-.774,2.927-2.448,2.678-3.186s-3.732-.206-4.061-.914,2.329-3.021,1.925-3.69-3.689.6-4.162-.019,1.63-3.448,1.092-4.017-3.474,1.377-4.07.87.853-3.718.205-4.157-3.09,2.1-3.783,1.733.008-3.816-.722-4.1-2.527,2.744-3.287,2.55-.889-3.713-1.669-3.812-1.778,3.274-2.566,3.274",
    transform: "translate(-261.702 -136.035)",
    fill: "none",
    stroke: "#a14b2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5105",
    "data-name": "Group 5105",
    transform: "translate(0 0.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1716",
    "data-name": "Path 1716",
    d: "M253,180.333c.4-.545,3.536,1.039,3.991.5.431-.512-1.756-3.237-1.3-3.784.426-.513,3.564,1.066,3.986.491.392-.535-2.083-3-1.715-3.618.339-.566,3.7.432,4-.222.276-.6-2.654-2.509-2.42-3.194.211-.621,3.7-.33,3.87-1.035.151-.638-3.089-1.968-2.98-2.683.1-.65,3.591-.937,3.649-1.657.053-.657-3.343-1.52-3.328-2.24.014-.661,3.448-1.36,3.428-2.078-.019-.663-3.485-1.181-3.535-1.9-.047-.663,3.316-1.654,3.24-2.364-.085-.79-3.6-1.014-3.765-1.773-.17-.774,2.927-2.448,2.678-3.186s-3.733-.206-4.061-.914,2.329-3.021,1.925-3.69-3.689.6-4.162-.019,1.63-3.448,1.092-4.017-3.474,1.377-4.07.87.853-3.718.205-4.157-3.09,2.1-3.783,1.733.008-3.816-.722-4.1-2.527,2.744-3.287,2.55-.889-3.713-1.669-3.812-1.778,3.274-2.567,3.274",
    transform: "translate(-241.701 -136.035)",
    fill: "none",
    stroke: "#a14b2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar6);
export default __webpack_public_path__ + "static/media/avatar6.f8a22b9147bff10b83b28b5629a27923.svg";
export { ForwardRef as ReactComponent };